import { useSessionStore } from "@/modules/auth/store/useSessionStore";
import { AdminUserRole } from "@/modules/common/types/Users.enum";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  minimumRole?: AdminUserRole;
  redirectTo?: string;
}

export const ProtectedRoute = ({ children, minimumRole, redirectTo = "*" }: ProtectedRouteProps) => {
  const { canUserSee } = useSessionStore();
  const location = useLocation();

  if (minimumRole && !canUserSee(minimumRole)) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
